/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
$(".jsTabs").hide();

// NOTE: facebookログイン後のURLの末尾が「#_=_」のようになりSyntax errorが出るので、それを回避するためにreplaceを使用
if ($(`.jsTabs${location.hash.replace("=", "")}`).length == 1) {
  const active_list = $(".jsTabsUi").find("li.active");
  const target_list = $(`.jsTabsUi a[href="${location.hash}"]`).closest("li");
  active_list.removeClass("active");
  target_list.addClass("active");
  $(location.hash).fadeIn();
} else if ($(`.jsTabs${location.hash}`).length > 1) {
  $(".jsTabsUi")
    .find("li.active a")
    .each(function () {
      $($(this).attr("href")).fadeIn();
    });
}

$(document).on("click", ".jsTabsUi li", function () {
  const this_tags_ui = $(this).closest(".jsTabsUi");
  this_tags_ui.find("li").removeClass("active");
  $(this).addClass("active");
  this_tags_ui.find("li a").each(function () {
    $($(this).attr("href")).hide();
  });

  $($(this).find("a").attr("href")).fadeIn();
  return false;
});
